import { render, staticRenderFns } from "./reTrait.vue?vue&type=template&id=9a137a66&"
import script from "./reTrait.vue?vue&type=script&lang=js&"
export * from "./reTrait.vue?vue&type=script&lang=js&"
import style0 from "./reTrait.vue?vue&type=style&index=0&id=9a137a66&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports